/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioContentTestResult } from './InternalApiScenarioContentTestResult';
import {
    InternalApiScenarioContentTestResultFromJSON,
    InternalApiScenarioContentTestResultFromJSONTyped,
    InternalApiScenarioContentTestResultToJSON,
    InternalApiScenarioContentTestResultToJSONTyped,
} from './InternalApiScenarioContentTestResult';

/**
 * Scenario content test run
 * @export
 * @interface InternalApiScenarioContentTestRun
 */
export interface InternalApiScenarioContentTestRun {
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestRun
     */
    time?: Date;
    /**
     * 
     * @type {Array<InternalApiScenarioContentTestResult>}
     * @memberof InternalApiScenarioContentTestRun
     */
    alertingIntervals: Array<InternalApiScenarioContentTestResult>;
}

/**
 * Check if a given object implements the InternalApiScenarioContentTestRun interface.
 */
export function instanceOfInternalApiScenarioContentTestRun(value: object): value is InternalApiScenarioContentTestRun {
    if (!('alertingIntervals' in value) || value['alertingIntervals'] === undefined) return false;
    return true;
}

export function InternalApiScenarioContentTestRunFromJSON(json: any): InternalApiScenarioContentTestRun {
    return InternalApiScenarioContentTestRunFromJSONTyped(json, false);
}

export function InternalApiScenarioContentTestRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentTestRun {
    if (json == null) {
        return json;
    }
    return {
        
        'time': json['time'] == null ? undefined : (new Date(json['time'])),
        'alertingIntervals': ((json['alertingIntervals'] as Array<any>).map(InternalApiScenarioContentTestResultFromJSON)),
    };
}

export function InternalApiScenarioContentTestRunToJSON(json: any): InternalApiScenarioContentTestRun {
    return InternalApiScenarioContentTestRunToJSONTyped(json, false);
}

export function InternalApiScenarioContentTestRunToJSONTyped(value?: InternalApiScenarioContentTestRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'time': value['time'] == null ? value['time'] : value['time'].toISOString(),
        'alertingIntervals': ((value['alertingIntervals'] as Array<any>).map(InternalApiScenarioContentTestResultToJSON)),
    };
}

